import { track } from "../analytics";
import { CsError } from "../CsError";
import type { Auth0ContextInterface } from '@auth0/auth0-react';

const origin = process.env.REACT_APP_API_ORIGIN ?? ''

export async function auth0MutationFunction<TResponse, TRequestBody>(body: TRequestBody, method: 'POST' | 'PUT' | 'DELETE', path: string, getAccessTokenSilently: Auth0ContextInterface['getAccessTokenSilently'], loginWithRedirect: Auth0ContextInterface['loginWithRedirect'], audience: string, scope: string) {
  const url = `${origin}/api/${path}`;

  // Try getting the token silently
  let accessToken = '';
  try {
    accessToken = await getAccessTokenSilently({ audience, scope });
  } catch (e) {
    console.warn('getAccessTokenSilently mutate() FAILED, redirecting to login…', e);
    await loginWithRedirect({
      appState: { returnTo: window.location.pathname + window.location.search }
    });
    throw new Error('Authentication required');
  }

  const res = await fetch(url, {
    method,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  if (res.ok) {
    try {
      return (await res.json()) as TResponse;
    } catch (e) {
      track('error', 'useApiMutation', {}, {
        message: 'Empty success response, returning empty object',
        error: JSON.stringify(e),
      });
      return {} as TResponse;
    }
  } else {
    let errorData: any = null;
    try {
      errorData = await res.json();
    } catch (e) {
      track('error', 'useApiMutation', {}, {
        message: 'Failed to parse error response as JSON',
        error: JSON.stringify(e),
      });
      errorData = { userErrorMessage: 'An error occurred' };
    }
    const err: CsError = {...errorData, status: res?.status }
    throw err 
  }
}
